<template>
  <div
    class="comment position-relative d-flex py-3 px-4 gap-3 align-items-center"
    :class="{ 'is-edit': isEdit }"
  >
    <eg-colored-dot-box
      :color="commentColor"
      :background-color="commentBackgroundColor"
    />
    <div class="w-100 pl-3">
      <div v-if="isEdit" class="text mt-2">
        <eg-b-form-textarea
          v-model="newCommentText"
          :placeholder="$t('essays.enterAnalysis')"
          rows="2"
          max-rows="4"
        />
      </div>
      <div v-else class="text">{{ comment.text }}</div>
    </div>

    <div class="flex-none pr-3">
      <div v-if="!isEdit" class="d-flex comment-actions">
        <eg-button
          size="md"
          type="secondary"
          icon="delete"
          @click="$emit('delete', comment)"
        >
          Delete
        </eg-button>
        <eg-button
          type="secondary"
          size="md"
          icon="pen-edit"
          class="ml-auto mr-2"
          @click="handleEdit"
        >
          Edit
        </eg-button>
      </div>
      <div v-else class="d-flex mt-2">
        <eg-button
          type="secondary"
          size="sm"
          class="ml-auto mr-2"
          @click="handleCancel"
        >
          Cancel
        </eg-button>
        <eg-button
          size="sm"
          type="primary"
          :is-loading="isLoading"
          @click="handleSave"
        >
          Save
        </eg-button>
      </div>
    </div>
    <eg-b-overlay :show="isLoading" no-wrap> </eg-b-overlay>
  </div>
</template>

<script>
import formatDate from "@/utils/formatDate";
import EgColoredDotBox from "@/components/global/eg/eg_colored_dot_box.vue";
import EgButton from "@/components/global/eg/buttons/eg_button.vue";

export default {
  components: {
    EgColoredDotBox,
    EgButton,
  },
  props: {
    index: {
      type: Number,
      required: true,
    },

    comment: {
      type: Object,
      required: true,
    },

    commentLoading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isLoading: false,
      isActive: false,
      newCommentText: this.comment.text || "",
      isEdit: false,
    };
  },

  computed: {
    date() {
      return formatDate(this.comment.createdAt);
    },

    commentColor() {
      return this.comment.color || "var(--color-surface-secondary-default)";
    },

    commentBackgroundColor() {
      return (
        this.comment.backgroundColor || "var(--color-surface-secondary-light)"
      );
    },
  },

  watch: {
    commentLoading() {
      if (!this.commentLoading) {
        this.isLoading = false;
      }
    },
  },

  methods: {
    handleEdit() {
      this.isEdit = true;
      this.newCommentText = this.comment.text;
    },

    handleCancel() {
      this.isEdit = false;
    },

    handleSave() {
      this.isEdit = false;
      this.isLoading = true;
      this.$emit("update", {
        commentId: this.comment.id,
        text: this.newCommentText,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.comment {
  .eg-new-button {
    pointer-events: none;
    opacity: 0;
  }
  &.active {
    background-color: var(--color-surface-neutral-hover);
  }
  &.active,
  &:hover {
    .eg-new-button {
      pointer-events: all;
      opacity: 1;
    }
  }

  &.is-edit {
    background-color: var(--color-surface-neutral-hover);

    .eg-new-button {
      pointer-events: all;
      opacity: 1;
    }
  }
}

.flex-none {
  flex: none;
}
.comment-actions {
  gap: 0.75rem;
}

.index {
  color: var(--Text-Secondary, #6c757d);
  font-family: Inter;
  font-size: 10px;
  font-weight: 700;
  line-height: 16px;
}

.comment {
  cursor: pointer;
  gap: 10px;

  &:not(:nth-child(1)) {
    border-top: 1px solid var(--color-stroke-neutral-default, #dfdfdf);
  }

  &:hover {
    background-color: var(--color-surface-neutral-hover, #f8f9fa);
  }
}

.text {
  color: var(--Text-Body, #212529);
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.info-text {
  color: var(--Text-Secondary, #6c757d);
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;

  b {
    color: var(--Text-Secondary, #6c757d);
  }
}
</style>
